module.exports = __webpack_public_path__ + "img/DSC_2785-xl.73f0058a.png";